module.exports = __webpack_public_path__ + "img/bmbf_logo.71784a7c.png";